export default function () {
      return {
        softwareSwitchList:[],
        softwarePluginList:[],
        softwareProductList:[],
        softwareProductOldList:[],
        softwareProductCurrentList:[],
      }
    }